import React from 'react';
import { StackModal } from 'Components/StackModal';
import ModalStore from 'common/stores/modal.store';
import { use100vh } from 'react-div-100vh';
import { S } from './style';

export const NewModal = ({ ModalId, children, onClose = () => {} }) => {
  const mobileHeight = use100vh();
  return (
    <StackModal modalID={ModalId}>
      <S.Overlay
        onClick={() => {
          ModalStore.hideModal(ModalId);
          onClose();
        }}
      />
      <S.Container mobileHeight={mobileHeight}>
        <S.Close
          onClick={() => {
            ModalStore.hideModal(ModalId);
            onClose();
          }}
        />
        {children}
      </S.Container>
    </StackModal>
  );
};
